import React, { useCallback } from 'react';
import { SnackbarKey, useSnackbar } from 'notistack';

// Material UI
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

// notistack `action` for a snackbar the reader should be able to close before it auto-hides —
// pass the returned callback as the enqueue option's `action`.
export const useSnackbarDismissAction = () => {
  const { closeSnackbar } = useSnackbar();

  return useCallback((key: SnackbarKey) => (
    <IconButton size="small" color="inherit" aria-label="Dismiss" onClick={() => closeSnackbar(key)}>
      <CloseIcon fontSize="small" />
    </IconButton>
  ), [closeSnackbar]);
};
